




































import { Component, Emit, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import { IndiceMap } from '../../core/models';
import { OptionalHistoricalData, FilterDateEvent, getDateFromDateFormatApi } from '../../core/utils';
import { HistoricalDate, HistoricalMinute } from '../utils';
import { Mounted } from '../../core/decorators';
import { AuthStoreHelper } from '../../core/mixins';

@Component
export default class Travel extends Mixins(AuthStoreHelper) {
    indices: HistoricalDate[] = [];
    @Prop() vehicleHistorical: OptionalHistoricalData;
    @Prop() filterDateEvent: FilterDateEvent;

    @Mounted
    init(): void {
        this.isOpen();
        this.processIndices(this.vehicleHistorical);
    }

    @Emit()
    isOpen(): void {}

    @Watch('vehicleHistorical')
    observableVehicleHistorical(value: OptionalHistoricalData) {
        this.processIndices(value);
    }

    @Watch('filterDateEvent')
    observableFilterDateEvent(value: FilterDateEvent) {
        if (this.vehicleHistorical) {
            this.processIndices(this.vehicleHistorical);
        }
    }

    processIndices(value: OptionalHistoricalData) {
        if (value) {
            this.indices = this.getDeepValue(value.indices, 'date', [], (dateMap: IndiceMap) =>
                this.getDeepValue(dateMap, 'hour', [], (hourMap: IndiceMap) =>
                    this.getDeepValue(hourMap, 'minute', '', (minuteMap: IndiceMap) =>
                        Array.isArray(minuteMap) ? minuteMap : [minuteMap]
                    )
                )
            );
        }
        if (this.indices) {
            this.indices = this.sortDates(this.indices);
        }
        if (this.indices && this.filterDateEvent && this.filterDateEvent.range) {
            //dateTimevariables
            let dateTimeFrom = getDateFromDateFormatApi(this.filterDateEvent.range.datetime_from);
            let dateTimeTo = getDateFromDateFormatApi(this.filterDateEvent.range.datetime_to);

            //remove from indices the ones outside dateTime range selected
            this.indices = this.filterDaysIndices(this.indices, dateTimeFrom, dateTimeTo);
        }
    }

    getDeepValue(indiceMap: IndiceMap, key: string, defaultValue: any, calculateValue: any) {
        return Object.keys(indiceMap).reduce((result, it) => {
            return [...result, { [key]: it, value: calculateValue(indiceMap[it]) }];
        }, defaultValue);
    }

    minuteSelected: any = null;

    getGTMSelectMinute(hourValue, minuteSelected) {
        if (!this.$store.state.userGroupSmartway) {
            return hourValue === minuteSelected ? 'success ga_btn_tracking_select_minute' : '';
        } else {
            return hourValue === minuteSelected ? 'success' : '';
        }
    }

    returnValue() {
        return 10;
    }

    @Emit()
    selectMinute(minute: HistoricalMinute) {
        return minute;
    }

    handleSelectMinute(minute: HistoricalMinute) {
        this.minuteSelected = minute;
        this.selectMinute(minute);
    }

    //
    //auxiliary functions for Sorting and Filtering indices
    //

    filterMinutesFrom(indicesMinutes: any[], minutes: number) {
        //initialize outputArray, iterator, variables
        let outputIndices = indicesMinutes;
        let itMinutes = 0;

        //find the first minute from date, this could be optimized with binary search
        while (outputIndices[itMinutes] && parseInt(outputIndices[itMinutes].minute) < minutes) {
            itMinutes++;
        }
        //check if there were any minutes left
        if (outputIndices[itMinutes]) {
            //at least one minute meets the criteria
            outputIndices = outputIndices.slice(itMinutes);
        } else {
            //no minute meets the criteria
            outputIndices = [];
        }

        return outputIndices;
    }

    filterHoursFrom(indicesHours: any[], date: Date) {
        //initialize outputArray, iterator, variables
        let outputIndices = indicesHours;
        let itHours = 0;
        let hours = date.getHours();
        let minutes = date.getMinutes();

        //find the first hour after or equal to date, this could be optimized with binary search
        while (outputIndices[itHours] && parseInt(outputIndices[itHours].hour) < hours) {
            itHours++;
        }
        //check if there were any hours left
        if (outputIndices[itHours]) {
            //at least one hour meets the criteria
            if (parseInt(outputIndices[itHours].hour) == hours) {
                //exact match
                outputIndices[itHours].value = this.filterMinutesFrom(outputIndices[itHours].value, minutes);
                outputIndices = outputIndices.slice(itHours);
            } else {
                outputIndices = outputIndices.slice(itHours);
            }
        } else {
            //no hour meets the criteria
            outputIndices = [];
        }

        return outputIndices;
    }

    filterMinutesTo(indicesMinutes: any[], minutes: number) {
        //initialize outputArray, iterator, variables
        let outputIndices = indicesMinutes;
        let itMinutes = outputIndices.length - 1;

        //find the last minute previous to minutes, this could be optimized with binary search
        while (outputIndices[itMinutes] && parseInt(outputIndices[itMinutes].minute) > minutes) {
            itMinutes--;
        }
        //check if there were any minutes left
        if (outputIndices[itMinutes]) {
            //at least one minute meets the criteria
            outputIndices = outputIndices.slice(0, itMinutes + 1);
        } else {
            //no minute meets the criteria
            outputIndices = [];
        }

        return outputIndices;
    }

    filterHoursTo(indicesHours: any[], date: Date) {
        //initialize outputArray, iterator, variables
        let outputIndices = indicesHours;
        let itHours = outputIndices.length - 1;
        let hours = date.getHours();
        let minutes = date.getMinutes();

        //find the last hour previous to date, this could be optimized with binary search
        while (outputIndices[itHours] && parseInt(outputIndices[itHours].hour) > hours) {
            itHours--;
        }
        //check if there were any hours left
        if (outputIndices[itHours]) {
            //at least one hour meets the criteria
            if (parseInt(outputIndices[itHours].hour) == hours) {
                //exact match
                outputIndices[itHours].value = this.filterMinutesTo(outputIndices[itHours].value, minutes);
                outputIndices = outputIndices.slice(0, itHours + 1);
            } else {
                outputIndices = outputIndices.slice(0, itHours + 1);
            }
        } else {
            //no hour meets the criteria
            outputIndices = [];
        }

        return outputIndices;
    }

    filterDaysIndices(indicesDays: any[], from: Date, to: Date) {
        //initialize outputArray, iterator, variables
        let outputIndices = indicesDays;
        let itDays = 0;
        let dayFrom = from.getDate();
        let dayTo = to.getDate();

        /////filter from
        //find the first day from dateFrom, this could be optimized with binary search
        while (outputIndices[itDays] && getDateFromDateFormatApi(outputIndices[itDays].date).getDate() < dayFrom) {
            itDays++;
        }
        //check if there were any days left
        if (outputIndices[itDays]) {
            //at least one day meets the criteria
            if (getDateFromDateFormatApi(outputIndices[itDays].date).getDate() == dayFrom) {
                //exact match
                outputIndices[itDays].value = this.filterHoursFrom(outputIndices[itDays].value, from);
            }
            outputIndices = outputIndices.slice(itDays);
        } else {
            //no day meets the criteria
            outputIndices = [];
        }

        /////filter To
        //reset iterator
        itDays = outputIndices.length - 1;

        //find the last day before dayTo, this could be optimized with binary search
        while (outputIndices[itDays] && getDateFromDateFormatApi(outputIndices[itDays].date).getDate() > dayTo) {
            itDays--;
        }
        //check if there were any days left
        if (outputIndices[itDays]) {
            //at least one day meets the criteria
            if (getDateFromDateFormatApi(outputIndices[itDays].date).getDate() == dayTo) {
                //exact match
                outputIndices[itDays].value = this.filterHoursTo(outputIndices[itDays].value, to);
            }
            outputIndices = outputIndices.slice(0, itDays + 1);
        } else {
            //no day meets the criteria
            outputIndices = [];
        }

        return outputIndices;
    }

    compareDatesFromStrings(d1: any, d2: any) {
        let date1 = getDateFromDateFormatApi(d1.date);
        let date2 = getDateFromDateFormatApi(d2.date);

        if (date1 < date2) {
            return -1;
        } else if (date2 < date1) {
            return 1;
        }

        return 0;
    }

    sortDates(dates: any[]) {
        return dates.sort(this.compareDatesFromStrings);
    }
}
